// src/components/routing/PrivateRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PrivateRoute = ({ children, permission, roles }) => {
    const { user, loading, hasPermission } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user?.must_change_password && location.pathname !== '/change-password') {
        return <Navigate to="/change-password" replace />;
    }

    // Role restriction check
    if (roles && roles.length > 0) {
        const userRole = user.role || 'user';
        if (!roles.includes(userRole) && userRole !== 'admin' && userRole !== 'vendor') {
            return <Navigate to="/vendor/dashboard" replace />;
        }
    }

    // Permission check using auth helper
    if (permission && !hasPermission(permission)) {
        return <Navigate to="/vendor/dashboard" replace />;
    }

    return children;
};

export default PrivateRoute;
